export default {
    login_verification_text: "Ciao {user}, abbiamo inviato un codice di verifica a {email}. Inserisci il codice per accedere",
    code_resent: "Codice di verifica reinviato con successo",
}
